import { useLocation } from 'react-router-dom';

import { FilterMobileBtn } from 'components/FilterBtn';
import {
	SignalsInsights,
	SignalsInsightsBookmarks,
	SignalsInsightsPopular
} from 'components/Insights';
import InsightsTab from 'components/InsightsTab';
import {
	FXSLeftColLayout,
	TwoColsMainLayout
} from 'components/Layouts';
import UserNoPremium from 'components/UserNoPremium';
import { InsightsType } from 'models/enums';
import { PremiumProps } from 'models/props';
import useTypeformToDatalayer from 'utils/useTypeformToDatalayer';
import { useIsLessThan } from 'fxs-utils';

export default function Home({ isPremium }: PremiumProps) {
	const isLessThan833 = useIsLessThan(833);
	const isLessThan1280 = useIsLessThan(1280);
	const { pathname } = useLocation();
	const splitLocation = pathname.split('/')[1].toLowerCase();
	useTypeformToDatalayer();

	return (
		<TwoColsMainLayout>
			{!isPremium && <UserNoPremium />}
			<FXSLeftColLayout
				id='fxs_signals_messaging_bar_inner'
				isLessThan1280={isLessThan1280}
				isLessThan833={isLessThan833}
				removePaddings={true}
				removeScroll={true}
				removeBg={true}
				isInsights={true}
			>
				<InsightsTab />
				{splitLocation === InsightsType.latest && <SignalsInsights />}
				{splitLocation === InsightsType.popular && (
					<SignalsInsightsPopular />
				)}
				{splitLocation === InsightsType.bookmarks && (
					<SignalsInsightsBookmarks />
				)}
				{isLessThan833 && splitLocation === InsightsType.latest && (
					<FilterMobileBtn />
				)}
			</FXSLeftColLayout>
		</TwoColsMainLayout>
	);
}
